import React from 'react';
import 'dayjs/locale/es';
import dayjs from 'dayjs';
import { Button, Card, formatCurrency, Table } from '@avila-tek/ui/src';
import { createColumnHelper } from '@tanstack/react-table';
import Link from 'next/link';
import {
  Benefit,
  ClientGoals,
  Company,
  Plan,
  Subscription,
  User,
} from '../../../models';
import AddToShopCartBtn from './AddToShopCartBtn';
import SelectBenefit from './SelectBenefit';
import { Alert } from '../../shared';

const columnHelper = createColumnHelper<ClientGoals>();

interface EmployeeGoalsTableProps {
  data: ClientGoals[];
  user: User;
  benefits: Benefit[];
  refreshGoals?: () => Promise<void>;
}

function EmployeeGoalsTable({
  data,
  user,
  benefits,
  refreshGoals,
}: EmployeeGoalsTableProps) {
  const [benefitSelected, setBenefitSelected] = React.useState('');

  const [preferenceBenefitPrice, setPreferenceBenefitPrice] = React.useState(
    ((user?.currentSubscription as Subscription)?.plan as Plan)?.couponPrice ||
      0
  );
  const [preferenceBenefits, setPreferenceBenefits] = React.useState(
    user?.discountCoupons || 0
  );

  const columns = [
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore library has a issue: https://github.com/TanStack/table/issues/4224
    columnHelper.accessor('metric', {
      header: 'Métrica',
    }),
    /**
     * @deprecated startDate and endDate are not used
     */
    // columnHelper.accessor('startDate', {
    //   header: 'Fecha de inicio',
    //   cell: (info) => `${dayjs(info.row.original.startDate).format('L')}`,
    // }),

    // columnHelper.accessor('endDate', {
    //   header: 'Fecha final',
    //   cell: (info) => `${dayjs(info.row.original.endDate).format('L')}`,
    // }),

    columnHelper.accessor('result', {
      header: 'Alcance del objetivo',
      cell: (info) =>
        `${Math?.round(
          (info.row.original.result / info.row.original.target) * 100
        )}%`,
    }),

    columnHelper.accessor('rewarded', {
      header: 'Puntos ganados',
    }),

    columnHelper.accessor('active', {
      header: 'Acciones',
      cell: (info) => (
        <div className="flex space-x-2">
          <AddToShopCartBtn
            clientGoals={info.row.original}
            benefitId={benefitSelected}
            preferenceBenefits={preferenceBenefits}
            setPreferenceBenefits={setPreferenceBenefits}
            preferenceBenefitPrice={preferenceBenefitPrice}
            refreshGoals={refreshGoals}
            userId={user._id}
          />
        </div>
      ),
    }),
  ];

  return (
    <Card className="overflow-x-auto p-5">
      <Alert
        title=""
        text={`El usuario tiene disponible ${preferenceBenefits} beneficios de descuento, a un precio de $${formatCurrency(
          preferenceBenefitPrice
        )} con valor de $${formatCurrency(5)}`}
        show={preferenceBenefits > 0}
      />
      <Table<ClientGoals>
        data={data?.length > 0 ? data : []}
        columns={columns}
        href={`/app/employees/${user?._id}?tab=assignGoal`}
      >
        <Table.Header>
          <Table.SearchInput />
          <SelectBenefit
            benefits={benefits}
            benefitSelected={benefitSelected}
            setBenefitSelected={setBenefitSelected}
          />
        </Table.Header>
        <Table.Content<ClientGoals> onClickRow={() => {}} />
        <Table.Footer>
          <Table.Pagination className="ml-auto" />
        </Table.Footer>
      </Table>
    </Card>
  );
}

export default EmployeeGoalsTable;
